import { getData, postData } from '../../utils/HttpUtils';
import { SharedAudioDetail } from './types';

export async function getSharedAudioDetail(
  share_code: string,
): Promise<SharedAudioDetail> {
  return getData('/api/oasis/share/audio_detail', { share_code });
}

export async function reportAudioPlay(params: {
  video_id?: string;
  share_code?: string;
}): Promise<void> {
  return postData('/api/oasis/audio_play_report', params);
}
